module.exports = __webpack_public_path__ + "img/xinhua.86282006.svg";